import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.xsell.flexiCard.title',
        defaultMessage:
            'Repay with <button>{noRepayments}</button> monthly instalments'
    },
    defaultFlexiCopyModeBenefitText: {
        id: '_.xsell.flexiCard.flexi_loan_benefit',
        defaultMessage:
            '<bold>Top for cost control:</bold> Scheduled repayments from the 1st month reduce interest costs.'
    },
    longerLoansCopyModeBenefitText: {
        id: '_.xsell.flexiCard.longer_loan_benefit',
        defaultMessage:
            '<bold>Top for cost control:</bold> Scheduled repayments from the 1st month reduce interest costs.'
    },
    shorterLoansCopyModeBenefitText: {
        id: '_.xsell.flexiCard.shorter_loan_benefit',
        defaultMessage:
            '<bold>Top for cost control:</bold> Scheduled repayments from the 1st month reduce interest costs.'
    },
    interestOnlyCopyModeBenefitText: {
        id: '_.xsell.flexiCard.interest_only_benefit',
        defaultMessage:
            '<bold>Top for cost control:</bold> Scheduled repayments from the 1st month reduce interest costs.'
    },
    flexi24CopyModeBenefitText: {
        id: '_.xsell.flexiCard.flexi24_benefit',
        defaultMessage:
            '<bold>Top for cost control:</bold> Scheduled repayments from the 1st month reduce interest costs.'
    },
    RBLCopyModeBenefitText: {
        id: '_.xsell.flexiCard.rbl_benefit',
        defaultMessage:
            '<bold>Top for flexibility:</bold> Free repayments from day 1'
    },
    RBLXsellPricing: {
        id: '_.xsell.flexiCard.rbl_xsell_pricing',
        defaultMessage: 'Pricing'
    },
    XsellPricing: {
        id: '_.xsell.flexiCard.interest_only_pricing',
        defaultMessage: 'Pricing'
    },
    RBLXsellInterest: {
        id: '_.xsell.flexiCard.rbl_xsell_interest',
        defaultMessage:
            '<fetching>{interest}%</fetching> interest per 30 days, no fees'
    },
    xSellInterest: {
        id: '_.xsell.flexiCard.xsell_interest',
        defaultMessage:
            '<fetching>{interest}%</fetching> interest per 30 days, no fees'
    },
    repayments: {
        id: '_.xsell.flexiCard.repayments',
        defaultMessage: 'Repayments'
    },
    repaymentAmount: {
        id: '_.xsell.flexiCard.repayment_amount',
        defaultMessage: '<fetching>{amount}</fetching> /mo'
    },
    viewSchedule: {
        id: '_.xsell.flexiCard.view_schedule',
        defaultMessage: 'View Schedule'
    },
    total: {
        id: '_.xsell.flexiCard.total',
        defaultMessage: 'Total repayment'
    },
    customise: {
        id: '_.xsell.flexiCard.customise',
        defaultMessage: 'Select Duration'
    },
    selectDuration: {
        id: '_.xsell.flexiCard.select_duration',
        defaultMessage: 'Select your loan duration'
    },
    duration: {
        id: '_.xsell.flexiCard.duration',
        defaultMessage: '{amount} Months'
    },
    durationNotAvailable: {
        id: '_.xsell.flexiCard.duration_not_available',
        defaultMessage: '{term} month loan only available between {min} - {max}'
    },
    continue: {
        id: '_.xsell.flexiCard.continue',
        defaultMessage: 'Continue With Offer'
    }
});
